import { defineComponent as _defineComponent } from 'vue'
import GenericAvatar from "@/components/shared/GenericAvatar.vue";
import { capitalize } from "@/helpers/filters";
import { User } from "@/types/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
    user: null,
    variant: { default: undefined },
    size: { default: "md" }
  },
  setup(__props: any) {



return { __sfc: true,GenericAvatar, capitalize }
}

})